<template>
    <layout-default>
        <div class="preloader-page">
            <div class="preloader large">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </layout-default>
</template>

<script>
    import LayoutDefault from "@/layouts/Default";
    export default {
        components:{
            LayoutDefault
        }
    }
</script>

<style scoped lang="scss">
    @function rem($value){
        @return unquote(($value/1px)/16+"rem")
    }



    $circlesCount:8;
    $speed:1s;

    .preloader-page{
        height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .preloader{
        width: rem(50px);
        height: rem(50px);
        display: inline-block;
        position: relative;

        span{
            position: absolute;
            background: $yellow;
            width: 12px;
            height: 12px;
            left: 0;
            top: 0;
            right: 0;
            border-radius: 100%;
            transform-origin: center 24.5px;
            margin: auto;
            -webkit-animation: preloader 1s infinite alternate;
            -o-animation: preloader 1s infinite alternate;
            animation: preloader 1s infinite alternate;
            //
            @for $i from 1 through $circlesCount{
                &:nth-child(#{$i}){
                    transform: rotate(#{$i * (360 / $circlesCount)}deg);
                }
            }
        }
    }

    @keyframes preloader{
        from{ transform: scale(1);}
        to{ transform: scale(0.3);}
    }
</style>